const params=[
    "数据统计模块-数据中心",
    "用户模块-用户列表",
    "前端上传管理-上传前端",
    "游戏模块-游戏管理",
    "商品模块-商品管理",
    "商品模块-评论管理",
    "商品/游戏园审核管理-审核管理",
    "用户反馈消息-反馈类型",
    "用户反馈消息-反馈列表",
    "商家模块-商家类型",
    "商家模块-商家管理",
    "商家模块-商家列表",
    "游戏圈模块-游戏圈列表",
    "分销模块-分销管理",
    "帮助中心设置-帮助中心管理",
    "帮助中心设置-防止诈骗指南",
    "近期找回模块-近期找回管理",
    "等级设置模块-等级设置管理",
    "等级设置模块-等级任务管理",
    "实名认证-用户实名认证列表",
    "速度代练报价价格配置-速度代练报价价格配置",
    "签到积分管理-积分管理",
    "交易商品订单管理-订单管理",
    "交易商品订单管理-售后退款列表",
    "角色员工管理-角色员工管理",
    "商家管理工具模块-商家管理工具列表",
    "商家管理工具模块-商家管理工具套餐列表",
    "商家管理工具模块-商家工具开通记录列表",
    "系统模块-包赔设置",
]
module.exports={
    params
}


// WEBPACK FOOTER //
// ./src/views/system/js/admin.js